<template>
  <div class="brand-slider u-s-p-b-80">
    <div class="container">
      <div class="brand-slider-content owl-carousel" data-item="5">
        <div class="brand-pic">
          <a href="#">
            <img src="assets/images/brand-logos/img1.jpg" alt="Brand Logo 1" />
          </a>
        </div>
        <div class="brand-pic">
          <a href="#">
            <img src="assets/images/brand-logos/img2.jpg" alt="Brand Logo 2" />
          </a>
        </div>
        <div class="brand-pic">
          <a href="#">
            <img src="assets/images/brand-logos/img3.jpg" alt="Brand Logo 3" />
          </a>
        </div>
        <div class="brand-pic">
          <a href="#">
            <img src="assets/images/brand-logos/img4.jpg" alt="Brand Logo 5" />
          </a>
        </div>
        <div class="brand-pic">
          <a href="#">
            <img src="assets/images/brand-logos/img5.jpg" alt="Brand Logo 6" />
          </a>
        </div>
        <div class="brand-pic">
          <a href="#">
            <img src="assets/images/brand-logos/img6.jpg" alt="Brand Logo 7" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>